// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-V2e","icon":"styles_icon__2b93_"};